/* eslint-disable react/no-danger */
import React from "react";
import { TERM_AND_CONDITIONS } from "constants/index";

export const TermsAndConditions = () => {
  return (
    <div className="body">
      <h2 className="tc">Términos y condiciones</h2>
      <div
        className="ql-editor"
        dangerouslySetInnerHTML={{ __html: TERM_AND_CONDITIONS }}
      />
    </div>
  );
};
